<script lang="ts">

    import { Styles } from 'sveltestrap';
    import './global.scss';
    import { Router, Route } from 'svelte-navigator';
    import Login from './Pages/Login.svelte';
    import Dashboard from './Pages/Dashboard.svelte';
    import RouteGuard from './Components/RouteGuard.svelte';
    import Form from './Pages/Form.svelte';
    import Notifications from './Components/Notifications.svelte';
    import { eventsChannelFactory, formsService, notificationsService, sessionService } from './Services';
    import type { EventsChannel } from './Services/EventsChannel';
    import { onMount } from 'svelte';
    import FormOffline from './Pages/FormOffline.svelte';

    const { isLoggedIn } = sessionService;

    let userChannel: EventsChannel;

    onMount(updateCssVars);

    $: if ($isLoggedIn) {
        userChannel = eventsChannelFactory.createEventsChannel(sessionService.user.id);
        userChannel.on('added_to_form', onAddedToForm);
        localStorageForms()
    }


    async function onAddedToForm(): Promise<void> {
        notificationsService.notify('Nuevo formulario', 'Ha sido asignado a un nuevo formulario.');
    }

    async function updateCssVars(): Promise<void> {
        window.document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }

    async function localStorageForms(): Promise<void> {
        const forms = await formsService.getForms();
        const dataString = JSON.stringify(forms);
        localStorage.setItem(`formsInstances`, dataString);        
    }

</script>

<svelte:window on:resize={updateCssVars} />

<Styles />

<Notifications />

<Router primary={false}>

    <Route path="/" component={Login} />
    
    <Route path="/inicio">
        <RouteGuard>
            <Dashboard />
        </RouteGuard>
    </Route>

    <Route path="/formulario/:instanceId">
        <RouteGuard>
            <Form />
        </RouteGuard>
    </Route>

    <Route path="/formulario/offline">
        <RouteGuard>
            <FormOffline />
        </RouteGuard>
    </Route>

</Router>
